// MediaLink — minimal komponent för att visa en extern medie-länk
// (Video / Artikel / Audio / Dokument). Bygg 89.
//
// • Returnerar null om media_url eller media_typ saknas, eller om url ej börjar med http(s)://
// • Ingen embed, inga thumbnails, ingen URL-analys — bara en dedikerad knapp + valfri beskrivning.
//
// Användning:
//   <MediaLink media_url={f.media_url} media_typ={f.media_typ} media_beskrivning={f.media_beskrivning} />
import { Film, FileText, Headphones, ExternalLink, Newspaper } from "lucide-react";

const LABELS = {
  Video:    { text: "Se filmen",        icon: Film },
  Artikel:  { text: "Läs mer",          icon: Newspaper },
  Audio:    { text: "Lyssna",           icon: Headphones },
  Dokument: { text: "Öppna dokument",   icon: FileText },
};

export default function MediaLink({ media_url, media_typ, media_beskrivning, compact = false }) {
  if (!media_url || !media_typ) return null;
  const safe = typeof media_url === "string" && /^https?:\/\//i.test(media_url.trim());
  if (!safe) return null;
  const spec = LABELS[media_typ];
  if (!spec) return null;
  const Icon = spec.icon;

  return (
    <div data-testid="media-link" className={compact ? "" : "mt-3"}>
      <a
        href={media_url.trim()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`media-link-${media_typ.toLowerCase()}`}
        className="inline-flex items-center gap-1.5 text-sm font-medium text-falu hover:text-falu-hover no-underline"
      >
        <Icon size={14} />
        <span>{spec.text}</span>
        <ExternalLink size={11} className="opacity-60" />
      </a>
      {media_beskrivning && (
        <p className="text-xs text-bark/65 mt-1 max-w-md leading-snug">{media_beskrivning}</p>
      )}
    </div>
  );
}
